import React from "react";
import styled from "styled-components";
import { FiFilter } from "react-icons/fi";

const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  background: #fff;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
`;

const FilterTabs = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const FilterTab = styled.button`
  padding: 0.5rem 1.5rem;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  background: ${props => props.$active ? '#007aff' : '#f5f5f5'};
  color: ${props => props.$active ? '#fff' : '#666'};
  position: relative;
  overflow: hidden;
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: 0.5s;
    z-index: -1;
  }

  &:hover {
    background: ${props => props.$active ? '#0066cc' : '#e5e5e5'};
    
    &:before {
      left: 100%;
    }
  }
`;

const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #ddd;
  background: #fff;
  color: #666;
  position: relative;
  overflow: hidden;
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(0,0,0,0.05), transparent);
    transition: 0.5s;
    z-index: -1;
  }

  &:hover {
    background: #f5f5f5;
    
    &:before {
      left: 100%;
    }
  }
`;

const FiltersSection = ({ activeFilter, setActiveFilter, userPlan }) => {
  if (userPlan === 'Free') return null;

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  return (
    <FiltersContainer>
      <FilterTabs>
        <FilterTab 
          $active={activeFilter === "diario"} 
          onClick={(e) => {
            e.preventDefault();
            handleFilterChange("diario");
          }}
        >
          Diário
        </FilterTab>
        <FilterTab 
          $active={activeFilter === "semanal"} 
          onClick={(e) => {
            e.preventDefault();
            handleFilterChange("semanal");
          }}
        >
          Semanal
        </FilterTab>
        <FilterTab 
          $active={activeFilter === "mensal"} 
          onClick={(e) => {
            e.preventDefault();
            handleFilterChange("mensal");
          }}
        >
          Mensal
        </FilterTab>
        <FilterTab 
          $active={activeFilter === "anual"} 
          onClick={(e) => {
            e.preventDefault();
            handleFilterChange("anual");
          }}
        >
          Anual
        </FilterTab>
      </FilterTabs>
      <FilterButton>
        <FiFilter /> Mais Filtros
      </FilterButton>
    </FiltersContainer>
  );
};

export default FiltersSection;